import DisplayName from "./displayName";
function App() {
  return (
    <div className="App">
     
       <DisplayName/>
    </div>
  );
}

export default App;
